module.exports = __webpack_public_path__ + "media/images/flags/ca-b166c1a1fe0d7b50ee45b16c50814c71.png";